import { useState } from "react";
import { useGameCacheRealtime } from "./useGameCacheRealtime";

/**
 * Composition hook wrapping game cache state and realtime subscription.
 * Extracted from App.js Pass 6a — behavior-preserving, no logic changes.
 */
export function useGameData() {
  const [games, setGames] = useState([]);
  const [byDate, setByDate] = useState({});
  const [dataSource, setDataSource] = useState("loading");
  const [lastUpdated, setLastUpdated] = useState(null);

  const { refresh: loadGames } = useGameCacheRealtime({
    setGames,
    setByDate,
    setDataSource,
    setLastUpdated,
  });

  return { games, byDate, dataSource, lastUpdated, loadGames };
}
